/**
 * Aruba groups store — read-only list with fixture fallback.
 */
import { create } from "zustand";
import { get as apiGet, ApiError } from "@/api/client";
import { ArubaGroupListSchema, type ArubaGroup } from "@/api/schemas/aruba";
import { MOCK_ARUBA_GROUPS } from "@/api/fixtures/aruba-groups";

interface State {
  data: ArubaGroup[];
  status: "idle" | "loading" | "ready" | "error";
  error: string | null;
  load: () => Promise<void>;
}

export const useArubaGroups = create<State>((set, get) => ({
  data: [],
  status: "idle",
  error: null,
  load: async () => {
    if (get().status === "loading") return;
    set({ status: "loading", error: null });
    try {
      const raw = await apiGet<unknown>("/aruba/groups/");
      set({ data: ArubaGroupListSchema.parse(raw), status: "ready" });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? `API error ${err.status}`
          : err instanceof Error
            ? err.message
            : "unknown error";
      set({
        data: MOCK_ARUBA_GROUPS,
        status: "error",
        error: `${message} — showing fixture data`,
      });
    }
  },
}));
